import { FactoryProvider } from '@angular/core';
import { OKTA_CONFIG, OktaConfig } from '@okta/okta-angular';
import { OktaAuth, OktaAuthOptions } from '@okta/okta-auth-js';
import { TcsConfigurationService } from 'src/app/core/configuration.service';

export function oktaConfigFactory(tcsConfigurationService: TcsConfigurationService): OktaConfig {
  const config = tcsConfigurationService.value;
  const oktaRedirect =
    window.location.protocol + '//' + window.location.host + '/implicit/callback';
  const issuer = `${config.okta.tenantUrl}/oauth2/default`;

  const oktaConfig: OktaAuthOptions = {
    issuer,
    scopes: ['email', 'openid'],
    clientId: config.okta.clientId,
    redirectUri: oktaRedirect,
  };

  return { oktaAuth: new OktaAuth(oktaConfig) };
}

export const oktaConfigProvider: FactoryProvider = {
  provide: OKTA_CONFIG,
  useFactory: oktaConfigFactory,
  deps: [TcsConfigurationService],
};
